export default __webpack_public_path__ + "static/media/sriqr.f6e3066c.svg";